/* eslint-disable global-require */

import angular from 'angular';

import DeliverPanoramicFormController from './panoramic-form.controller';
import './panoramic-form.styles.scss';

export default angular.module('autoboard.formUploadPanoramic', [])
  .directive('formUploadPanoramic', () => {
    'ngInject';

    return {
      controller: DeliverPanoramicFormController,
      restrict: 'E',
      scope: {
        exit: '&',
        show: '=',
        vehicle: '=',
      },
      templateUrl: require('./panoramic-form.template.html'),
    };
  })
  .name;
